export default "__VITE_ASSET__DeFzIWgU__"